module.exports = __webpack_public_path__ + "img/oldThree.354017f8.png";